// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconReorder: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 13 }) => {
    return (
        <svg focusable="false" viewBox="0 0 12 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.357 7.075A.386.386 0 0 1 0 6.668l.01-.193c.11-2.267 1.922-4.046 4.12-4.046H7.5V1.355c0-.37.289-.667.647-.667.16 0 .314.06.432.171l1.797 1.67a.4.4 0 0 1 .124.288.4.4 0 0 1-.124.287L8.58 4.774a.63.63 0 0 1-.432.172.657.657 0 0 1-.647-.668V3.204H4.13C2.332 3.204.85 4.66.76 6.514l-.01.193a.38.38 0 0 1-.393.368M8.25 4.038l1.315-1.221L8.25 1.595zM11.644 6.3c.206.01.366.194.356.407l-.009.193c-.11 2.267-1.922 4.046-4.12 4.046H4.5v1.074a.657.657 0 0 1-.647.668.63.63 0 0 1-.432-.172l-1.797-1.67a.4.4 0 0 1-.125-.288.4.4 0 0 1 .125-.287L3.422 8.6a.63.63 0 0 1 .432-.172c.356 0 .646.298.646.668v1.074h3.37c1.798 0 3.282-1.456 3.371-3.31l.01-.193a.38.38 0 0 1 .393-.368M3.75 9.337l-1.314 1.221L3.75 11.78z"
            />
        </svg>
    );
};

export default React.memo(IconReorder);
